import React, { useEffect, useState, useReducer, useContext, useRef } from "react";
import { useForm } from 'react-hook-form';
import { Link, useHistory } from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import api from '../../services/api';
import { ReactSearchAutocomplete } from 'react-search-autocomplete';
import Swal from "sweetalert2";
import InputMask from 'react-input-mask';
import Modal from 'react-modal';
import { ToggleSwitch } from "../../components/ToggleSwitch";
import DatePicker, { registerLocale } from 'react-datepicker';
import { StyledForm } from "../../styled-components/StyledForm.style";
import { Multiselect } from 'multiselect-react-dropdown';

export const ModalTimeSheet = ({
    atividades,
    isDesktop,
    peritosList,
    isOpen,
    formData,
    onGetPerito,
    setIsOpen,
    ariaHideApp
}) => {

    const [showAdvanceTimesheet, setAdvanceTimesheet] = useState(false);
    const [showAdvanceFood, setAdvanceFood] = useState(false);
    var [horaFinal, setHoraFinal] = useState(null);
    var [horaInicio, setHoraInicio] = useState(null);
    var [horaFinal, setHoraFinal] = useState(null);
    var [descricao, setDescricao] = useState(null);
    var [desconto, setDesconto] = useState("00:00");
    var [atividade, setAtividade] = useState(null);
    var [idAtividade, setIdAtividade] = useState(null);
    var [idPeritos, setPeritosId] = useState([]);
    const [meuTimesheet, setMeuTimesheet] = useState(false);
    const [discountMeal, setDiscountMeal] = useState(false);
    const [activitiesShow, setActivitiesShow] = React.useState(false);
    var [searchActivitiesItem, setSearchActivitiesItem] = useState([]);
    var [searchActivitiesItens, setSearchActivitiesItens] = useState([]);
    const [startAcitivitiesDate, setStartAcitivitiesDate] = useState(new Date());
    const [searchActivitiesString, setSearchActivitiesString] = useState("");
    var [searchTimesheetItens, setSearchTimesheetItens] = useState([]);
    const [searchTimesheetString, setSearchTimesheetString] = useState("");
    const [buttonTimeSheetShow, setButtonTimeSheetShow] = React.useState(true);
    const [timeSheetShow, setTimeSheetShow] = React.useState(false);
    var [searchTimesheetItem, setSearchTimesheetItem] = useState([]);
    const [inputValue, getInputValue] = useState('');
    const multiselectRef = useRef();

    const advanceFood = { name: 'advanceFood', label: 'Descontar Refeição' };
    const advanceTimesheet = { name: 'advanceTimesheet', label: 'Meu lançamento' };




    useEffect(() => {
        if (!isOpen) {
            setSearchActivitiesItem(null);
            setSearchActivitiesItens([]);
            setSearchActivitiesString("");
            setSearchTimesheetItem(null);
            setSearchTimesheetItens([]);
            setSearchTimesheetString("");
            setButtonTimeSheetShow(true);
            setTimeSheetShow(false);
            setActivitiesShow(false);
            setAdvanceTimesheet(false);
            setAdvanceFood(false);
            setPeritosId([]);
            setAtividade(null);
            setIdAtividade(null);
            setStartAcitivitiesDate(new Date());
            setHoraInicio(null);
            setDescricao(null);
            setDesconto(null);
            setMeuTimesheet(false);
            setDiscountMeal(false);
        }
    }, [isOpen]);




    const style = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: "0px",
            minWidth: '35%',
            overflowY: 'auto',
            minHeight: '45%',
            maxHeight: '90%'
        },
        overlay: {
            zIndex: 9999
        }
    };

    const searchStyling = {
        borderRadius: "10px",
        boxShadow: "none",
        "background-color": "white",
        width: "100%"
    };

    const history = useHistory();
    const { register } = useForm();

    const atividadePost = async (params) => {
        let result = null;
        try {
            const response = await api.post(`Timesheet/atividade`, params);
            result = response.data;
            return result;
        } catch (err) {
            return result;
        }
    }

    const timesheetSearch = async (value) => {
        let result = null;
        try {
            const response = await api.get(`Timesheet/search?search=${value}&length=10`);
            result = response.data;
            return result;
        } catch (err) {
            return result;
        }
    }

    const timesheetPost = async (values) => {
        let result = null;
        let payload = {
            idPericia: values.idPericia == 0 ? null : values.idPericia,
            idRegulacao: values.idRegulacao == 0 ? null : values.idRegulacao,
        }
        try {
            const response = await api.post(`Timesheet`, payload);
            result = response.data;
            return result;
        } catch (err) {
            return result;
        }
    };

    const atividadeSearch = async (value) => {
        let result = null;
        try {
            const response = await api.get(`Timesheet/atividade/search?search=${value}&length=10`);
            result = response.data;
            return result;
        } catch (err) {
            return result;
        }
    }


    const handleDateChange = (date) => {
        setStartAcitivitiesDate(date);
    }

    const handleHoraInicial = (hora) => {
        horaInicio = hora;
        setHoraInicio(horaInicio);
    }

    const handleHoraFinal = (hora) => {
        horaFinal = hora;
        setHoraFinal(horaFinal);
    }

    const handleDescricao = (valor) => {
        descricao = valor;
        setDescricao(descricao);
    }

    const handleDesconto = (desconto) => {
        desconto = desconto;
        setDesconto(desconto);
    }

    const handleOnHoverActivities = (result) => { }

    const getTimesheetModalToggle = (status) => {
        setAdvanceTimesheet(status);
        setMeuTimesheet(status);
    };

    const getFoodModalToggle = (status) => {
        setAdvanceFood(status);
        setDiscountMeal(status);
    };

    const closeModal = () => {
        setIsOpen(false);
    };

    const afterOpenModal = () => { };

    const getAtividade = (currentValue, value) => {
        var atividadeResult = atividades.filter(function (o) {
            return o.key == value;
        });

        atividade = atividadeResult[0].value;
        idAtividade = atividadeResult[0].key;
        setAtividade(atividade);
        setIdAtividade(idAtividade);
    };

    const formTimesheet = async () => {
        let payload = searchTimesheetItem;
        const timeSheetResult = await timesheetPost(payload);
        formData(null, 1, 10);
        history.push(`/timesheetdetalhespage/#${timeSheetResult.data.idTimesheet}`);
    };

    const redirectTimesheetDetalhes = async () => {
        history.push(`/timesheetdetalhespage/#${searchTimesheetItem.idTimesheet}`);
    };

    const handleOnSelectActivities = (item) => {
        searchActivitiesItem = item;

        if (item != null) {
            setActivitiesShow(true);
        }
        else {
            setActivitiesShow(false);
        }
        setSearchActivitiesItem(searchActivitiesItem);
    };

    const handleOnSearchActivities = async (search, results) => {
        if (search.length > 2) {
            const acitivitiesResult = await atividadeSearch('-');
            if (!!acitivitiesResult) {
                searchActivitiesItens = []
                acitivitiesResult.data.map((item, index) => {
                    searchActivitiesItens.push({
                        idTimesheet: item.idTimesheet,
                        numeroTimesheet: item.numeroTimesheet,
                        disciplina: item.disciplina,
                        clienteNome: item.clienteNome,
                        seguradoNome: item.seguradoNome,
                        idPericia: item.idPericia,
                        sigla: item.sigla,
                        name: item.numeroTimesheet + ' - ' + item.sigla + ' - ' + item.seguradoNome + ' - ' + item.clienteNome
                    });
                });
                setSearchActivitiesItens(searchActivitiesItens);
                setSearchActivitiesString(search);
            }
        }
    };

    const handleOnSearchTimesheet = async (search, results) => {
        if (search.length > 2) {
            const timesheetResult = await timesheetSearch(`${search}`);
            if (!!timesheetResult) {
                searchTimesheetItens = []
                timesheetResult.data.map((item, index) => {
                    searchTimesheetItens.push({
                        id: item.id,
                        idTimesheet: item.idTimesheet,
                        numeroTimesheet: item.numeroTimesheet,
                        disciplina: item.disciplina,
                        clienteNome: item.clienteNome,
                        seguradoNome: item.seguradoNome,
                        periciaLider: item.periciaLider,
                        idPericia: item.idPericia,
                        idRegulacao: item.idRegulacao,
                        sigla: item.sigla,
                        name: item.sigla + ' - ' + item.seguradoNome + ' - ' + item.clienteNome
                    });
                });
                setSearchTimesheetItens(searchTimesheetItens);
                setSearchTimesheetString(search);
            }
        }
    }

    const formActivities = async () => {
        let descontofinal = "00:00";
        let idPeritosfinal = [];
        if (searchActivitiesItem != null
            && idAtividade != null
            && startAcitivitiesDate != null
            && horaInicio != null
            && horaFinal != null) {

            if (idPeritos != null) {
                idPeritosfinal = idPeritos;
            }

            if (desconto != null) {
                descontofinal = desconto.target.value;
            }

            let payload = {
                idTimesheet: searchActivitiesItem.idTimesheet,
                meuTimesheet: meuTimesheet,
                peritos: idPeritosfinal,
                idAtividade: idAtividade,
                descricao: descricao?.target?.value,
                dataLancamento: startAcitivitiesDate,
                timeInicial: horaInicio.target.value,
                timeFinal: horaFinal.target.value,
                descontarRefeicao: discountMeal,
                timeDesconto: descontofinal
            }
            Swal.showLoading()
            const activitiesResult = await atividadePost(payload);
            if (activitiesResult != null) {
                setIsOpen(false);
                registrationSuccess();
                formData(null, 1, 10);
            }
            else {
                registrationFailure();
            }
        }
        else {
            registrationInformation();
        }
    };

    const handleOnSelectTimesheet = (item) => {
        searchTimesheetItem = item;
        if (searchTimesheetItem.idTimesheet == null) {
            setButtonTimeSheetShow(true);
        }
        else {
            setButtonTimeSheetShow(false);
        }

        if (item != null) {
            setTimeSheetShow(true);
        }
        else {
            setTimeSheetShow(false);
        }

        setSearchTimesheetItem(searchTimesheetItem);
    };

    const onRemovePerito = (currentValue, value) => { }

    const handleOnFocusTimesheet = () => { }
    const handleOnFocusActivities = () => { }

    const registrationSuccess = () => {
        Swal.fire({
            title: "Sucesso",
            text: "Cadastro realizado com sucesso",
            icon: "success",
            // customClass: {
            //     confirmButton: 'default-button-alert'
            //   },
            confirmButtonText: "OK",
        });
    };

    const registrationFailure = () => {
        Swal.fire({
            title: "Atenção",
            text: "Ops, ocorreu um erro ao realizar o cadastro. Tente novamente em instantes.",
            icon: "error",
            // customClass: {
            //     confirmButton: 'default-button-alert'
            //   },
            confirmButtonText: "OK",
        });
    };


    const registrationInformation = () => {
        Swal.fire({
            title: "Informação",
            text: "Preencha todos os campos necessários",
            icon: "info",
            // customClass: {
            //     confirmButton: 'default-button-alert'
            //   },
            confirmButtonText: "OK",
        });
    };

    return (
        <Modal
            isOpen={isOpen}
            onAfterOpen={afterOpenModal}
            onRequestClose={closeModal}
            contentLabel="Timesheet Atividades"
            style={style}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
        >
            <Tabs>
                <StyledForm>
                    <p className="modal-close" onClick={closeModal}>X</p>
                </StyledForm>
                <TabList>
                    <StyledForm>
                        <Tab>Timesheet</Tab><Tab>Atividades</Tab>
                    </StyledForm>
                </TabList>
                <TabPanel>
                    <StyledForm>
                        <div className="position-relative form-group">
                            <p className="modal-title">Lançamento de Timesheet</p>
                            <div className="position-relative form-group modal-width">
                                <ReactSearchAutocomplete
                                    items={searchTimesheetItens}
                                    onSearch={handleOnSearchTimesheet}
                                    onHover={handleOnSearchTimesheet}
                                    onSelect={handleOnSelectTimesheet}
                                    onFocus={handleOnSearchTimesheet}
                                    inputSearchString={searchTimesheetString}
                                    styling={searchStyling}
                                />

                            </div>
                            {
                                timeSheetShow ?
                                    <div>
                                        <p className="modal-info">Nº do Timesheet</p>
                                        <p className="modal-info-data"> {searchTimesheetItem.numeroTimesheet} </p>
                                        <p className="modal-info">Sigla </p>
                                        <p className="modal-info-data">{searchTimesheetItem.sigla}  </p>
                                        <p className="modal-info">Disciplina </p>
                                        <p className="modal-info-data">{searchTimesheetItem.disciplina}  </p>
                                        <p className="modal-info">Lider </p>
                                        <p className="modal-info-data">{searchTimesheetItem.periciaLider}  </p>
                                        <p className="modal-info">Cliente </p>
                                        <p className="modal-info-data">{searchTimesheetItem.clienteNome} </p>
                                        <p className="modal-info">Segurado </p>
                                        <p className="modal-info-data">{searchTimesheetItem.seguradoNome}  </p>
                                    </div>
                                    :
                                    <div></div>
                            }
                        </div>
                        <div className="position-relative form-group modal-align-center">
                            {
                                timeSheetShow ?
                                    buttonTimeSheetShow ?
                                        <input className='default-button-red' value='Adicionar' type="button" onClick={formTimesheet} />
                                        :
                                        <input className='default-button-red' value='Acessar' type="button" onClick={redirectTimesheetDetalhes} />
                                    : null
                            }
                        </div>
                    </StyledForm>
                </TabPanel>
                <TabPanel>
                    <StyledForm>
                        <div className="form-wrapper filter-container">
                            <p className="modal-title">Lançamento de Atividade</p>
                            <div className="position-relative form-group modal-width">
                                <ReactSearchAutocomplete
                                    items={searchActivitiesItens}
                                    onSearch={handleOnSearchActivities}
                                    onHover={handleOnHoverActivities}
                                    onSelect={handleOnSelectActivities}
                                    onFocus={handleOnFocusActivities}
                                    inputSearchString={searchActivitiesString}
                                    styling={searchStyling}
                                />
                            </div>
                            {
                                activitiesShow ?
                                    <div>
                                        <p className="modal-info">IdTimesheet</p>
                                        <p className="modal-info-data"> {searchActivitiesItem.idTimesheet} </p>
                                        <p className="modal-info">Nº do Timesheet</p>
                                        <p className="modal-info-data"> {searchActivitiesItem.numeroTimesheet} </p>
                                        <p className="modal-info">Cliente </p>
                                        <p className="modal-info-data">{searchActivitiesItem.clienteNome} </p>
                                        <p className="modal-info">Segurado </p>
                                        <p className="modal-info-data">{searchActivitiesItem.seguradoNome}  </p>
                                        <p className="modal-info">IdPericia </p>
                                        <p className="modal-info-data">{searchActivitiesItem.idPericia} </p>
                                        <p className="modal-info">Sigla </p>
                                        <p className="modal-info-data">{searchActivitiesItem.Sigla} </p>
                                        <div className="form-wrapper filter-container">
                                            <div className="form-container flex-column justify-content-center">
                                                <ToggleSwitch config={advanceTimesheet} setStatus={(status) => getTimesheetModalToggle(status)} />
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <div></div>
                            }
                        </div>

                        {
                            activitiesShow ?
                                <div>

                                    <div className={!!showAdvanceTimesheet ? `input-hide position-relative form-group` : `position-relative form-group`} style={{ width: '100%' }} >
                                        <Multiselect
                                            required='required'
                                            placeholder={'Profissionais'}
                                            showCheckbox="true"
                                            options={peritosList} // Options to display in the dropdown
                                            selectedValues={peritosList.selectedValue} // Preselected value to persist in dropdown
                                            onSelect={onGetPerito} // Function will trigger on select event
                                            onRemove={onRemovePerito} // Function will trigger on remove event
                                            displayValue="nome" // Property name to display in the dropdown options
                                            ref={multiselectRef}
                                        />
                                    </div>

                                    <div style={{ width: '100%' }} className="position-relative form-group">
                                        <select name={'idAtividade'} placeholder={'Atividade'} onChange={(event) => { getAtividade(inputValue, event.target.value) }} style={{ width: '100%' }} className="input-form">
                                            <option value={'key'}>{''}</option>
                                            {
                                                atividades.map((opt, iOpt) =>
                                                    <option key={iOpt} value={opt['key']}>
                                                        {opt['value']}
                                                    </option>)
                                            }
                                        </select>
                                    </div>

                                    <div style={{ width: '100%' }} className="position-relative form-group">
                                        <textarea rows="3" className="input-form" cols="35" placeholder='Descrição' name='descricao' onBlur={handleDescricao} />
                                    </div>

                                    <div style={{ width: '50%' }} className="position-relative form-group">
                                        <DatePicker dateFormat="dd/MM/yyyy" className="input-form" selected={startAcitivitiesDate} onChange={handleDateChange} />
                                    </div>

                                    {(() => {
                                        if (isDesktop) {
                                            return (
                                                <div>
                                                    <div style={{ width: '100%' }} className="position-relative form-group">
                                                        <InputMask autoComplete="off" mask="99:99" type='text' className="input-form" placeholder='Hora Inicial' name='HoraInicial' onBlur={handleHoraInicial} />
                                                    </div>
                                                    <div style={{ width: '100%' }} className="position-relative form-group">
                                                        <InputMask autoComplete="off" mask="99:99" type='text' className="input-form" placeholder='Hora Final' name='HoraFinal' onBlur={handleHoraFinal} />
                                                    </div>
                                                </div>
                                            )
                                        }
                                        return (
                                            <div>
                                                <div style={{ width: '100%' }} className="position-relative form-group">
                                                    <InputMask autoComplete="off" mask="99:99" type='text' className="input-form" placeholder='Hora Inicial' name='HoraInicial' onBlur={handleHoraInicial} />
                                                </div>
                                                <div style={{ width: '100%' }} className="position-relative form-group">
                                                    <InputMask autoComplete="off" mask="99:99" type='text' className="input-form" placeholder='Hora Final' name='HoraFinal' onBlur={handleHoraFinal} />
                                                </div>
                                            </div>
                                        )
                                    })()}
                                    <div className="form-container flex-column justify-content-center">
                                        <ToggleSwitch config={advanceFood} setStatus={(status) => getFoodModalToggle(status)} />
                                    </div>
                                    <div style={{ width: '50%' }} className={!!showAdvanceFood ? `position-relative form-group` : `input-hide position-relative form-group`}>
                                        <InputMask autoComplete="off" mask="99:99" type='text' className="input-form" placeholder='Desconto' name='Desconto' onBlur={handleDesconto} />
                                    </div>
                                    <div className="position-relative form-group modal-align-center">
                                        <input className='default-button-red' value='Adicionar' type="button" onClick={formActivities} />
                                    </div>
                                </div>
                                :
                                <div></div>
                        }
                    </StyledForm>
                </TabPanel>
            </Tabs>
        </Modal>);
};
